const focusableSelector = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

export const focusRelativeElement = (
  currentElement: HTMLElement | null,
  direction: 1 | -1,
) => {
  if (!currentElement) return

  const focusableElements = Array.from(
    document.querySelectorAll<HTMLElement>(focusableSelector),
  ).filter(
    (element) =>
      element.tabIndex >= 0 &&
      element.getClientRects().length > 0 &&
      window.getComputedStyle(element).visibility !== 'hidden',
  )
  const currentIndex = focusableElements.indexOf(currentElement)
  if (currentIndex < 0) return

  focusableElements[currentIndex + direction]?.focus()
}
